import { makeActionCreator } from '../../config/store/utils'
import { getSuppliers } from '../../services/suppliers'
import { PUBLIC_URL } from '../../config/settings/environment'

export const GET_SUPPLIERS = 'GET_SUPPLIERS'
export const GET_SUPPLIERS_ERROR = 'GET_SUPPLIERS_ERROR'
export const GET_SUPPLIERS_SUCCESS = 'GET_SUPPLIERS_SUCCESS'
export const onGetSuppliers = makeActionCreator(GET_SUPPLIERS)
export const onGetSuppliersError = makeActionCreator(GET_SUPPLIERS_ERROR, 'payload')
export const onGetSuppliersSuccess = makeActionCreator(GET_SUPPLIERS_SUCCESS, 'payload')
export const onGetSuppliersThunk = () => async dispatch => {
  dispatch(onGetSuppliers())

  try {
    const { data } = await getSuppliers()
    const suppliers = data?.proveedores?.map(supplier => ({
      dni: supplier?.rut,
      enabled: supplier?.habilitado,
      logo: `${PUBLIC_URL}/assets/images/airlines/${supplier?.rut}.png`,
      message: supplier?.mensaje,
      name: supplier?.nombre,
      url: supplier?.url,
      visible: supplier?.visible
    }))

    return dispatch(onGetSuppliersSuccess({ suppliers }))
  } catch (error) {
    return dispatch(
      onGetSuppliersError({
        error: {
          code: error.code,
          message: error.reason
        }
      })
    )
  }
}
